// extracted by mini-css-extract-plugin
export default {"base":"styles_base__vQAMb","green":"styles_green__rzcNz","white":"styles_white__K9b8u","large":"styles_large__6oJ9x"};